import { render } from "./VersionChecker.vue?vue&type=template&id=522019e6&ts=true"
import script from "./VersionChecker.vue?vue&type=script&lang=ts"
export * from "./VersionChecker.vue?vue&type=script&lang=ts"

import exportComponent from "/root/thelounge/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__